import { Injectable } from '@angular/core';
import { appServerResources } from '../app server constants';
import { BasehttpService } from './basehttp.service';

@Injectable({
  providedIn: 'root'
})
export class OrderSlotService {

  constructor(public httpServiceProvider: BasehttpService) { }

  // order
  getShiftSlotsByOrderSourceId(orderSource,date,from) {
    let url = appServerResources.SERVER_PATH + "LookupService" + appServerResources.VERSION + "/CustomerService/getShiftSlotsByOrderSourceId/" + orderSource+"/"+date+"/"+from;
    return this.httpServiceProvider.get(url)
  }

  holdShiftSlotForSlotId(orderPostObject){
    let url = appServerResources.SERVER_PATH + "LookupService" + appServerResources.VERSION + "/CustomerService/holdShiftSlotForSlotId/";
    return this.httpServiceProvider.post(url,orderPostObject)
  }

  unHoldShiftSlotForClientId(id) {
    let url = appServerResources.SERVER_PATH + "LookupService" + appServerResources.VERSION + "/CustomerService/unHoldShiftSlotForClientId/" + id;
    return this.httpServiceProvider.get(url)
  }

  //reservation
  getReservationSlotForDateTimeAndLocationIdForWebsite(locationId,date,from) {
    let url = appServerResources.SERVER_PATH + "ReservationService" + appServerResources.VERSION + "/CustomerService/getReservationSlotForDateTimeAndLocationIdForWebsite/" +date+"/"+from+ "/" +locationId;
    return this.httpServiceProvider.get(url)
  }

  holdReservationSlotForSlotId(orderPostObject){
    let url = appServerResources.SERVER_PATH + "ReservationService" + appServerResources.VERSION + "/CustomerService/holdReservationSlotForSlotId/";
    return this.httpServiceProvider.post(url,orderPostObject)
  }

  unHoldReservationSlotForClientId(id) {
    let url = appServerResources.SERVER_PATH + "ReservationService" + appServerResources.VERSION + "/CustomerService/unHoldReservationSlotForClientId/" + id;
    return this.httpServiceProvider.get(url)
  }

  getAllRequestTypeByLocationId(id) {
    let url = appServerResources.SERVER_PATH + "LookupService" + appServerResources.VERSION + "/CustomerService/getAllRequestTypeByLocationId/" + id;
    return this.httpServiceProvider.get(url)
  }

  getAllContactPreferenceByLocationId(id) {
    let url = appServerResources.SERVER_PATH + "LookupService" + appServerResources.VERSION + "/CustomerService/getAllContactPreferenceByLocationId/" + id;
    return this.httpServiceProvider.get(url)
  }

  addForWebsite(orderPostObject){
    let url = appServerResources.SERVER_PATH + "ReservationService" + appServerResources.VERSION + "/CustomerService/addForWebsite/";
    return this.httpServiceProvider.post(url,orderPostObject)
  }

}
